import FormField from '@/components/FormField';
import TimeInput from '@/common/TimeInput';
import { Validation } from '@/utils';
import { useEffect } from 'react';

type TimeFrameRangeItemProps = {
  label: string;
  startTime: string;
  endTime: string;
  name: string;
  onChange: (name: string, value: string) => void;
  onDelete?: () => void;
  disabled?: boolean;
};
const TimeFrameRangeItem = ({ label, startTime, endTime, name, onChange, onDelete, disabled }: TimeFrameRangeItemProps) => {
  // auto focus name input on mount
  useEffect(() => {
    (document.querySelector(`input[name="timesFrameRanges.${label}.name"]`) as HTMLElement).focus();
  }, []);

  return (
    <div className="TimeFrameRange border rounded-4">
      <div className="d-flex align-items-center flex-nowrap gap-3 mb-2 border-bottom">
        {label}
        <FormField
          placeholder="name"
          value={name}
          name={`timesFrameRanges.${label}.name`}
          onChange={(event) => onChange('name', event.target.value)}
          valid={!name.trim() ? Validation.ValidityType.INVALID : undefined}
          disabled={disabled}
          options={{
            group: {
              className: 'flex-grow-0 shadow-box',
            },
          }}
        />
        <div className="d-flex align-items-center flex-nowrap flex-grow-1 gap-2">
          <TimeInput
            className="flex-grow-1"
            value={startTime}
            name={`timesFrameRanges.${label}.startTime`}
            onChange={(value) => onChange('startTime', String(value))}
            disabled={disabled}
          />
          <i className="sv sv-arrow-right" />
          <TimeInput
            className="flex-grow-1"
            value={endTime}
            name={`timesFrameRanges.${label}.endTime`}
            onChange={(value) => onChange('endTime', String(value))}
            disabled={disabled}
          />
        </div>
        {!disabled && (
          <button className="btn btn-icon" onClick={onDelete} disabled={disabled}>
            <i className="sv sv-trash2" />
          </button>
        )}
      </div>
      <div className="mb-2">
        {startTime} - {endTime}
      </div>
    </div>
  );
};

export default TimeFrameRangeItem;
